const InvisibleWrap = ({invisible, children}) => {
  return (<div className={'relative inline-block'}>
    <div className="invisible" aria-hidden="true">
      {invisible}
    </div>
    <p className={'absolute inset-0 whitespace-nowrap'}>{children}</p>
  </div>)
}

export default InvisibleWrap;